import { Box, Text } from "@chakra-ui/react";
import { FunctionComponent, useContext } from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import { GetUserProfileContext } from "src/Context/UserProfile";
import { hasPermission } from "src/helpers/hasPermission";

import Loader from "src/assets/images/splash_screen_loader.json";
import Lock from "src/assets/images/lock.json";

type Props = {
  children: any;
  permission: any;
};

const CheckPermission: FunctionComponent<Props> = ({
  children,
  permission,
}) => {
  const { data, isFetching } = useContext(GetUserProfileContext);

  if (isFetching && !data) {
    return (
      <Box
        textAlign={"center"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        height={"80%"}
        position={"fixed"}
        width={"80%"}
        margin={"0px auto"}
      >
        <Player
          src={Loader}
          style={{ width: "100px" }}
          className="player"
          loop
          autoplay
        />
      </Box>
    );
  }

  const hasAccess = hasPermission(data?.user?.permissions, permission);

  return (
    <>
      {!hasAccess ? (
        <Box
          style={{
            width: "50%",
            margin: "5em 0px 0px 15em",
            textAlign: "center",
          }}
        >
          <Player
            src={Lock}
            style={{ width: "150px" }}
            className="player"
            loop
            autoplay
          />
          <Text fontSize={"13px"}>
            You currently do not have access to this module, kindly contact your
            organisation admin for access.
          </Text>
        </Box>
      ) : (
        children
      )}
    </>
  );
};

export default CheckPermission;
